// extracted by mini-css-extract-plugin
module.exports = {"customBorder":"articlecard-module--customBorder--1L8_q"};